
export enum EarlyCutoffCd {
	ESL = 'ESL',
	HAS_EARLY_CUTOFF = 'Has Early Cutoff',
	NO_EARLY_CUTOFF = 'No Early Cutoff'}

